import { Injectable } from '@angular/core';

import { ProductsConfig } from './models/product-interface-config';

@Injectable({
	providedIn: 'root',
})
export class ProductsConfigHelper {
	products: ProductsConfig[];

	constructor() {
		this.products = [
			{
				id: '4e81bc3e-7a7f-48b4-a4f4-3ff862463554',
				name: 'Gestão de Saúde',
				requiredAttributesDependent: ['name', 'cpf', 'cpf_titular'],
				requiredAttributesOwner: ['name', 'cpf'],
			},
			{
				id: '81f0a415-546c-4f96-96ec-fe8a919441bf',
				name: 'Gestão Operacional',
				requiredAttributesDependent: [
					'name',
					'birthday',
					'cpf',
					'cpf_titular',
					'type',
				],
				requiredAttributesOwner: [
					'name',
					'cpf',
					'birthday',
					'mothers_name',
					'gender',
					'registration',
					'admission_date',
					'postal_code',
					'street',
					'number',
					'neighborhood',
					'state',
					'city',
				],
			},
		];
	}

	findById(id: string): ProductsConfig | null {
		return this.products.find((element) => element.id === id) || null;
	}

	getProducts(): ProductsConfig[] {
		return this.products;
	}
}
